<template>
  <div class="page_four">
    <div class="container">
      <div class="moon">
        <img src="@/assets/img/2moon1.png" alt="" />
      </div>
      <div class="icons">
        <div class="icon icon1">
          <h2>BATTLE</h2>
          <p>High level Strategy PvP</p>
        </div>
        <div class="icon icon2">
          <h2>COLLECT</h2>
          <p>Hundreds of Heroes and Equipment</p>
        </div>
        <div class="icon icon3">
          <h2>EARN</h2>
          <p>Play-to-Earn Revolution</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
};
</script>
<style scoped lang="scss">
.page_four {
  width: 100%;
  height: 1081px;
  position: relative;
  .container {
    position: absolute;
    top: 0px;
    left: 5rem;
    transform: translateX(-50%);
    width: 1701px;
    height: 882px;
    background: url("~@/assets/img/2Star1.png") center no-repeat;
    .moon {
      width: 100%;
      height: 149px;
      display: flex;
      justify-content: flex-end;
      img {
        width: 131px;
        height: 149px;
        margin-right: 38px;
      }
    }
    .icons {
      margin-top: 65px;
      width: 100%;
      height: 471px;
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      // margin: 61px auto;
      .icon1,
      .icon2,
      .icon3 {
        cursor: pointer;
        width: 342px;
        // width: 100vw;
        height: 471px;

        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: icomoon;
        text-align: center;
        // margin: 0 auto;
        h2 {
          width: 190px;
          height: 30px;
          font-size: 41px;
          font-weight: 700;
          margin-top: 310px;
        }
        p {
          margin-top: 20px;
          width: 160px;
          font-size: 19px;
        }
      }
      .icon1 {
        margin-left: 269px;
        background: url("~@/assets/img/2icon1.png") no-repeat;
        color: #7e171a;
      }
      .icon2 {
        margin-left: 61px;
        background: url("~@/assets/img/2icon2.png") no-repeat;
        color: #79420b;
      }
      .icon3 {
        margin-left: 61px;
        background: url("~@/assets/img/2icon3.png") no-repeat;
        color: #311265;
      }
    }
  }
}

@media (max-width: 1199px) {
  .page_four {
    overflow: hidden;
    width: 100vw;
    height: 28.8rem;
    position: relative;
    .container {
      width: 100%;
      height: 100%;
      background: url("~@/assets/img/2Star1.png") center repeat-y;
      background-size: 10rem 5.146667rem;
      display: flex;
      flex-direction: column;
      .moon {
        width: 100%;
        height: 2rem;
        display: flex;
        justify-content: flex-end;
        img {
          width: 1.733333rem;
          height: 2rem;
          margin-right: 0.506667rem;
        }
      }
      .icons {
        width: 100%;
        height: 23.466667rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .icon {
          // border: 1px solid pink;
          width: 4.426667rem;
          height: 6.16rem;
          font-family: icomoon;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 auto;
          h2 {
            margin-top: 3.84rem;
            width: 2.533333rem;
            height: 0.586667rem;
            // border: 1px solid #fff;
            font-size: 0.533333rem;
            font-weight: 700;
          }
          p {
            margin-top: 0.133333rem;
            width: 2.346667rem;
            font-size: 0.266667rem;
            // border: 1px solid #000;
          }
        }
        .icon1 {
          // margin-left: 1.12rem;
          background: url("~@/assets/img/2icon1.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #7e171a;
        }
        .icon2 {
          background: url("~@/assets/img/2icon2.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #79420b;
        }
        .icon3 {
          background: url("~@/assets/img/2icon3.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #311265;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .page_four {
    overflow: hidden;
    width: 100vw;
    height: 28.8rem;
    position: relative;
    .container {
      width: 100%;
      height: 100%;
      background: url("~@/assets/img/2Star1.png") center repeat-y;
      background-size: 10rem 5.146667rem;
      display: flex;
      flex-direction: column;
      .moon {
        width: 100%;
        height: 2rem;
        display: flex;
        justify-content: flex-end;
        img {
          width: 1.733333rem;
          height: 2rem;
          margin-right: 0.506667rem;
        }
      }
      .icons {
        width: 100%;
        height: 23.466667rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .icon {
          // border: 1px solid pink;
          width: 4.426667rem;
          height: 6.16rem;
          font-family: icomoon;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 auto;
          h2 {
            margin-top: 3.84rem;
            width: 2.533333rem;
            height: 0.586667rem;
            // border: 1px solid #fff;
            font-size: 0.533333rem;
            font-weight: 700;
          }
          p {
            margin-top: 0.133333rem;
            width: 2.346667rem;
            font-size: 0.266667rem;
            // border: 1px solid #000;
          }
        }
        .icon1 {
          // margin-left: 1.12rem;
          background: url("~@/assets/img/2icon1.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #7e171a;
        }
        .icon2 {
          background: url("~@/assets/img/2icon2.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #79420b;
        }
        .icon3 {
          background: url("~@/assets/img/2icon3.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #311265;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page_four {
    overflow: hidden;
    width: 100vw;
    height: 28.8rem;
    position: relative;
    .container {
      width: 100%;
      height: 100%;
      background: url("~@/assets/img/2Star1.png") center repeat-y;
      background-size: 10rem 5.146667rem;
      display: flex;
      flex-direction: column;
      .moon {
        width: 100%;
        height: 2rem;
        display: flex;
        justify-content: flex-end;
        img {
          width: 1.733333rem;
          height: 2rem;
          margin-right: 0.506667rem;
        }
      }
      .icons {
        width: 100vw;
        height: 23.466667rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .icon {
          // border: 1px solid pink;
          width: 4.426667rem;
          height: 6.16rem;
          font-family: icomoon;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 auto;
          h2 {
            margin-top: 3.84rem;
            width: 2.533333rem;
            height: 0.586667rem;
            // border: 1px solid #fff;
            font-size: 0.533333rem;
            font-weight: 700;
          }
          p {
            margin-top: 0.133333rem;
            width: 2.933333rem;
            font-size: 0.266667rem;
            // border: 1px solid #000;
          }
        }
        .icon1 {
          // margin-left: 1.12rem;
          background: url("~@/assets/img/2icon1.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #7e171a;
        }
        .icon2 {
          background: url("~@/assets/img/2icon2.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #79420b;
        }
        .icon3 {
          background: url("~@/assets/img/2icon3.png") no-repeat;
          background-size: 4.426667rem 6.16rem;
          color: #311265;
        }
      }
    }
  }
}
</style>
